module.exports = __webpack_public_path__ + "static/media/ugpg-banner.bc9e47e9.png";